export default __webpack_public_path__ + "static/Rare_Mushroom-cb5e400e59e58f19397fbf013c667957.png";